import React, { FC } from 'react';

import { IconProps } from './icon.types';

export type SuccessCircleIconProps = IconProps;

const SuccessCircleIcon: FC<SuccessCircleIconProps> = ({ iconColor = '#344054' }) => (
  <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.31657 7.31657L6.31657 9.31657L10.3166 5.31657M13.9832 7.31657C13.9832 10.9985 10.9985 13.9832 7.31657 13.9832C3.63467 13.9832 0.649902 10.9985 0.649902 7.31657C0.649902 3.63467 3.63467 0.649902 7.31657 0.649902C10.9985 0.649902 13.9832 3.63467 13.9832 7.31657Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);
export default SuccessCircleIcon;
